import type { HelpFile } from '../../types/help'
import { FunctionGroupRequestDetailTestIds } from '../../../testids/FunctionGroupRequestDetailTestIds'

export const functionGroupRequestDetailHelp: HelpFile = {
  docPage: '/docs/governance/function-group-requests',
  texts: {
    [FunctionGroupRequestDetailTestIds.functionGroupRequestDetailPage]:
      'Detailansicht einer Funktionsgruppen-Anfrage — ihre Positionen, Begründung und der aktuelle Genehmigungsstatus.',
    [FunctionGroupRequestDetailTestIds.btnCancelRequest]:
      'Storniert die gesamte Anfrage. Alle offenen Positionen werden zurückgezogen und die Genehmiger benachrichtigt.',
    [FunctionGroupRequestDetailTestIds.cardTitleJustification]:
      'Begründung des Antragstellers für diesen Zugriff — von Genehmigern und Auditoren bei der Entscheidung geprüft.',
    [FunctionGroupRequestDetailTestIds.cardTitleRequestDetails]:
      'Kopfdaten der Anfrage — Antragsteller, Zielidentität, Einreichungszeitpunkt und Gesamtstatus.',
    [FunctionGroupRequestDetailTestIds.requestStatusBadge]:
      'Aktueller Gesamtstatus der Anfrage (offen, genehmigt, abgelehnt, storniert, abgeschlossen).',
  },
}
